import { useQuery } from "@tanstack/react-query";
import { apiRequest } from "@/utils/apiRequest";
import { GET_DATA_TO_CREATE_PARCEL } from "@/constants/Query";
import { ICurrentShipmentCreateUz } from "@/types/apiResponse.types";
import { toast } from "react-toastify";

export const useGetShipmentDataToCreateRequest = (parcelId?: number) => {
  return useQuery<{
    data: {
      data: ICurrentShipmentCreateUz;
    };
  }>({
    queryKey: [GET_DATA_TO_CREATE_PARCEL],
    queryFn: () =>
      apiRequest(GET_DATA_TO_CREATE_PARCEL, "get")
        .then((res) => res)
        .catch((error) => {
          toast.error(
            error?.response?.data?.error?.message ||
              "Error occured getting parcel details",
            {
              position: "top-center",
              toastId: "CREATE_PARCEL",
            },
          );
          throw new Error();
        }),
    enabled: !parcelId,
    retry: 2,
  });
};
